import React from "react";

import NaytaLiuku from "./NaytaLiuku";
import NaytaKoriinNappi from "./NaytaKoriinNappi";
import NaytaPaluuNappi from "./NaytaPaluuNappi";
import { Link, useParams } from "react-router-dom";

const NaytaTuote = (props) => {
  const { tila, asetatila } = props;

  const { kuvaId } = useParams();
  const tuoteId = kuvaId.split("_")[0];

  const tuote = tila.kortit.filter((t) => t.Ttunnus === tuoteId)[0];
  const kuvat = tuote.Kuvat;
  document.documentElement.style.setProperty("--animaatio", "none");
  let selite = "";
  if (tila.frisbee)
    selite = (
      <div>
        {tuote.Selite}
        <br />
        <br />
        Katso&nbsp;
        <Link to="/sanasto">
          <strong>Sanastosta</strong>
        </Link>
        &nbsp;mitä termit tarkoittavat!
        <br />
        <br />
      </div>
    );

  return (
    <div className="liukuTila">
      <NaytaKoriinNappi asetatila={asetatila} tuoteId={tuoteId} />
      <NaytaPaluuNappi />
      <b>
        <br /> {tuote.Tuote}: {tuote.Hinta} €
      </b>
      <br />
      <br />
      {selite}
      <NaytaLiuku tila={tila} kuvat={Object.values(kuvat)} />
    </div>
  );
};

export default NaytaTuote;
